import { http, HttpResponse } from 'msw';

import { apiRoutes } from '@features/campaigns/details/consts/apiRoutes.ts';
import { mockedOneflightBrandsData } from '@shared/mocks/requests/oneflightBrands/oneflightBrands.fixtures';

export const oneflightBrandsRequests = [
  http.get(`*${apiRoutes.getOneFlightClientsBrands(':campaignId')}`, () => {
    return HttpResponse.json(mockedOneflightBrandsData);
  }),
];
